import "./machineCard.css";
import GraphicsRadius from "../graphicsRadius/GraphicRadius";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faGear } from '@fortawesome/free-solid-svg-icons'
const MachineCard = (props)=>{

    return(
        <div className="mc-container">
            <div className="mc-title">
                {props.description}
            </div>
            {typeof props.numberMachines == "number" ? (
                <div className="mc-description">
                <FontAwesomeIcon icon={faGear}></FontAwesomeIcon> Máquinas: {props.numberMachines}
            </div>):(null)}
            
            <div className="mc-graphic">
                <GraphicsRadius legend={"OEE"} signal={"%"} backGraphic={100} data={props.oeeMedium.toFixed(2) ?? 0}></GraphicsRadius>
            </div>
            <div className="mc-variables-box">
                    <div className="mc-text">
                        Indicadores individuais
                    </div>
                    <div className="mc-variables">
                        <span>
                            P: {props.performanceMedium.toFixed(2) ?? 0}%
                        </span>
                        <span>
                            D: {props.disponibilityMedium.toFixed(2) ?? 0}%
                        </span>
                        <span>
                            Q: {props.qualityMedium.toFixed(2) ?? 0}%
                        </span>
                    </div>
                    
                </div>
            {typeof props.openMachines == "function" ? (
                <div className="mc-button">
                <Button className="full-size" onClick={()=>{props.openMachines()}} disabled={(props.numberMachines > 0) ? false : true}>Máquinas</Button>
                </div>) : (null)}
            
        </div>
    )

}

export default MachineCard;